import React, { ReactElement, Suspense } from 'react';

import { Spin } from 'antd';
import styled from 'styled-components';

type ReturnType<T> = (props: T) => ReactElement;

interface LoadingProps {
	size?: string;
	color?: string;
}

const Loading: React.FC<LoadingProps> = ({ size, color }) => {
	return (
		<SpinnerContainer>
			<Spin size='large' />
		</SpinnerContainer>
	);
};

const SpinnerContainer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

// eslint-disable-next-line @typescript-eslint/ban-types
export const withLoading = <T extends object>(Component: React.ComponentType<T>): ReturnType<T> => {
	return (props: T) => (
		<Suspense fallback={<Loading />}>
			<Component {...props} />
		</Suspense>
	);
};
